module.exports = __webpack_public_path__ + "static/media/undraw_navigator_a479.159bfd7c.svg";